module.exports = __webpack_public_path__ + "static/media/finance-industry.384b7b01.svg";